const capt = {
  // 生成图片验证码
  captImg: `/userApi/v1/Captcha/img`,
  // 验证码唯一id
  captbard: `/userApi/v1/Captcha/get_background`
};

export default capt;
